import React from 'react';
import Icon from '@/shared/components/Icon';
import {formatBirthdate} from '@/shared/utils/formatBirthdate';

export interface OrderStep {
    label: string;
    date: string | null;
    completed: boolean;
}

/**
 * Vertical order-status checklist (Order Date / Sample Received / Labs Processed),
 * per Nathan's v6 mockup: a teal outline check for completed steps, an empty grey
 * circle for pending ones, with the date inline after the label.
 */
const OrderStatusTimeline: React.FC<{steps: OrderStep[]}> = ({steps}) => {
    return (
        <ol className="flex flex-col gap-2.5">
            {steps.map((step) => (
                <li
                    key={step.label}
                    data-testid="order-step"
                    data-completed={String(step.completed)}
                    className="flex items-center gap-2.5">
                    {step.completed ? (
                        <Icon name="circle-check" className="h-5 w-5 shrink-0 text-mld-success" />
                    ) : (
                        <Icon name="circle" className="h-5 w-5 shrink-0 text-gray-300" />
                    )}
                    <span className="text-[14px] font-semibold text-mld-text-primary">{step.label}</span>
                    {step.date && (
                        <span className="text-[14px] text-mld-text-primary/60">- {formatBirthdate(step.date)}</span>
                    )}
                </li>
            ))}
        </ol>
    );
};

export default OrderStatusTimeline;
